import { useState } from 'react'
import { Menu } from 'lucide-react'
export const toGO = () => {
  window.location.href = 'https://bitvavo.tw/'
}

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <nav className='border-b border-gray-100'>
      {/* Desktop Navigation */}
      <div className='hidden md:flex items-center justify-between px-6 py-4'>
        <div className='flex items-center space-x-8'>
          <div className='text-xl font-bold flex items-center gap-2 cursor-pointer' onClick={toGO}>
            <img src='/logo.jpg' alt='Bitvavo Logo' className='w-6 h-6 object-contain rounded-md' />
            bitvavo
          </div>
          <div className='flex space-x-6'>
            <a href='#' className='text-gray-600 hover:text-gray-900'>
              Assets
            </a>
            <a href='#' className='text-gray-600 hover:text-gray-900'>
              Solutions
            </a>
            <a href='#' className='text-gray-600 hover:text-gray-900'>
              Information
            </a>
            <a href='#' className='text-gray-600 hover:text-gray-900'>
              Support
            </a>
          </div>
        </div>
        <div className='flex items-center space-x-4'>
          <button onClick={toGO} className='text-gray-600 hover:text-gray-900'>
            Login
          </button>
          <button onClick={toGO} className='px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700'>
            Sign up
          </button>
          <button onClick={toGO} className='flex items-center text-gray-600'>
            EN
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className='md:hidden'>
        <div className='flex items-center justify-between px-6 py-4'>
          <div className='text-xl font-bold flex items-center gap-2 cursor-pointer' onClick={toGO}>
            <img src='/logo.jpg' alt='Bitvavo Logo' className='w-6 h-6 object-contain rounded-md' />
            bitvavo
          </div>
          <button onClick={toGO} className='p-2'>
            <Menu className='w-6 h-6' />
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`${isMenuOpen ? 'max-h-screen' : 'max-h-0'} overflow-hidden transition-all duration-300 ease-in-out`}>
          <div className='px-6 py-2 space-y-4'>
            <a href='#' className='block py-2 text-gray-600'>
              Assets
            </a>
            <a href='#' className='block py-2 text-gray-600'>
              Solutions
            </a>
            <a href='#' className='block py-2 text-gray-600'>
              Information
            </a>
            <a href='#' className='block py-2 text-gray-600'>
              Support
            </a>
            <div className='pt-4 space-y-3'>
              <button onClick={toGO} className='block w-full text-left py-2 text-gray-600'>
                Login
              </button>
              <button onClick={toGO} className='block w-full px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700'>
                Sign up
              </button>
              <button onClick={toGO} className='block w-full text-left py-2 text-gray-600'>
                EN
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navigation
